import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Clock } from "lucide-react";
import FeuillesDeTempsTab from "@/features/rh/feuilles-de-temps/components/FeuillesDeTempsTab";

export const Route = createFileRoute("/_app/rh/feuilles-de-temps/")({
  loader: requirePermission(PERMISSIONS.RH.FEUILLES_DE_TEMPS.VIEW),
  staticData: {
    title: "Feuilles de Temps",
    icon: Clock,
    tab_icon: Clock,
    permission: PERMISSIONS.RH.FEUILLES_DE_TEMPS.VIEW,
    module: "rh",
    section: "Ressources Humaines",
    order: 40,
    showInNav: true,
    showInTab: true,
  },
  component: FeuillesDeTempsTab,
});
